const BASE = import.meta.env.VITE_API_BASE_URL ?? '';

export type HistoricalImportFormat = 'Summary' | 'Full' | 'Vendor';

export interface HistoricalImportResult {
  surveysCreated: number;
  responsesImported: number;
  warnings: string[];
}

export function getHistoricalImportTemplateUrl(format: HistoricalImportFormat): string {
  return `${BASE}/api/historical-import/template/${format.toLowerCase()}`;
}

export async function importVendorStats(
  accessToken: string,
  file: File
): Promise<HistoricalImportResult> {
  const form = new FormData();
  form.append('file', file);

  const res = await fetch(`${BASE}/api/historical-import/vendor-stats`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${accessToken}` },
    body: form,
  });

  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error((err as { message?: string }).message ?? `Stats import failed: ${res.status}`);
  }

  return res.json();
}

export async function importHistoricalData(
  accessToken: string,
  file: File,
  format: HistoricalImportFormat
): Promise<HistoricalImportResult> {
  const form = new FormData();
  form.append('file', file);

  const res = await fetch(`${BASE}/api/historical-import?format=${format}`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${accessToken}` },
    body: form,
  });

  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error((err as { message?: string }).message ?? `Import failed: ${res.status}`);
  }

  return res.json();
}
